import { render, staticRenderFns } from "./lockcomponent.vue?vue&type=template&id=31c64842&scoped=true"
import script from "./lockcomponent.vue?vue&type=script&lang=js"
export * from "./lockcomponent.vue?vue&type=script&lang=js"
import style0 from "./lockcomponent.vue?vue&type=style&index=0&id=31c64842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c64842",
  null
  
)

export default component.exports